// frontend/src/app/claim-annotator/adapters/auth-user-context.ts
import { Injectable, Signal, computed, inject } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { UserContext } from '../ports/user-context.port';

@Injectable({ providedIn: 'root' })
export class AuthUserContext implements UserContext {
  private auth = inject(AuthService);

  readonly currentUserLabel: Signal<string> = computed(() => {
    const info = this.auth.getUserInfo();
    return info?.email ?? 'anonymous';
  });
}
